import { Expose } from "@nts/std/serialization";

@Expose()
export class ExposeAllObjects extends Object { }
